import React from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, Link } from 'react-router-dom';
import { useEffect } from 'react';
import SpaceEsSlider from '../st/SpaceEsSlider';
import { useState } from 'react';
import { reqMainStAction, resetMainStAction } from '../../modules/hp/mainModule';
//import { isNullableTypeAnnotation } from '../../../../../Library/Caches/typescript/3.9/node_modules/@babel/types/lib/index';
import {isMobileOnly} from 'react-device-detect'

const HpSpaceTourBlock = styled.div`
    ${!isMobileOnly&&`
      width: 100%;
      max-width: 1176px;
      margin: 0 auto;    
    `};
`;

const HpSpaceTourTitleBlock = styled.h3`
    //margin: 0 4vw 10px;
    //margin-bottom: 10px;
    position: relative;
    font-size: ${isMobileOnly?"20px":"30px"};
    
  ${isMobileOnly?`display:flex; align-items:center; justify-content:space-between;line-height:29px;height:29px; margin: 0 4vw;`:`margin: 0 0 10px; text-align: center;`}
`;

const HpSpaceToureGoBlock = styled.div`
    ${isMobileOnly?`
      padding: 0 15px;
      img {width: 6px; height: 12px;}
    `:`
      position: absolute;
      top: 6px;
      right: 0;
      font-size: 14px;
      text-decoration: underline;    
    `}

`;

const TourContentsBlock = styled.div`
  width: 100vw;
  //margin-left: -4vw;
  overflow-x: scroll;
  white-space: nowrap;
  height: 294px;
  margin-top: 30px !important;
  img {height:289px; margin-right: 20px; &:first-of-type {margin-left: 4vw;} &:last-of-type {margin-right: 4vw;}}
`;

const HpSpaceTour = () => {

    const dispatch = useDispatch();

    const { mainStItems } = useSelector(
        ({ loadingReducer, mainReducer }) => ({
            loading: loadingReducer['main/MAIN_ST'],
            mainStItems: mainReducer.mainStItems,
        })
    );

    useEffect(() => {
        dispatch(reqMainStAction());
    }, [dispatch])

    if (mainStItems === null || mainStItems === undefined) {
        return <div />;
    }
    return (
        <HpSpaceTourBlock>
            <HpSpaceTourTitleBlock>
                <div><b style={{ fontWeight: '700' }}>공간</b> 투어는 어디?</div>
                <Link to="/st">
                  <HpSpaceToureGoBlock>
                      {isMobileOnly?<img src="/assets/images/icon/arrow_right.svg"/>:"전체보기"}
                  </HpSpaceToureGoBlock>
                </Link>
            </HpSpaceTourTitleBlock>
          {isMobileOnly?
            <TourContentsBlock>
              {mainStItems.map(item => <Link key={item.st_id} to={`/stdetail?id=${item.st_id}`}><img alt="" src={item.cntnts_main_img}/></Link>)}
            </TourContentsBlock>
            :
            <SpaceEsSlider items={mainStItems} count={mainStItems.length} marginTop="30px"/>
          }

        </HpSpaceTourBlock>
    );
};

export default HpSpaceTour;
